var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-input',{attrs:{"formatter":_vm.mascaraValor,"placeholder":"R$ 0,00","value":_vm.formattedValue},model:{value:(_vm.valueCurrency),callback:function ($$v) {_vm.valueCurrency=$$v},expression:"valueCurrency"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }